import api from "@/api/axiosConfig.js";
import { handleSuccessResponse, handleErrorResponse } from '@/api/apiUtils.js';

const MODULE_NAME = 'VPN_API';

export const vpnAPI = {

  keys_get: async (showNotification = false) => {
    try {
      const response = await api.get('/vpn/keys');
      return handleSuccessResponse(response, MODULE_NAME, 'Получить все ключи', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получить все ключи');
    }
  },

  key_post: async (param, showNotification = false) => {
    try {
      const response = await api.post('/vpn/keys', param);
      return handleSuccessResponse(response, MODULE_NAME, 'Создать ключ', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'создать ключ');
    }
  },

  key_delete: async (key_id, showNotification = false) => {
    try {
      const response = await api.delete(`/vpn/keys/${key_id}`);
      return handleSuccessResponse(response, MODULE_NAME, 'Удалить ключ', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'удалить ключ');
    }
  },

  metrics_get: async (showNotification = false) => {
    try {
      const response = await api.get(`/vpn/metrics`);
      return handleSuccessResponse(response, MODULE_NAME, 'Получить метрику', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получить метрику');
    }
  },

  metrics_history_get: async (key_id, showNotification = false) => {
    try {
      const response = await api.get(`/vpn/metrics/${key_id}/history`);
      return handleSuccessResponse(response, MODULE_NAME, 'Получить историю метрики', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получить историю метрики');
    }
  },
};